<template>
  <div :class="[...cssClasses, 'pain_locations']">
    <PainMaleFigure
      v-if="gender !== 'f'"
      :body-parts="bodyParts"
    />
    <PainFemaleFigure
      v-if="gender === 'f'"
      :body-parts="bodyParts"
    />
  </div>
</template>

<script setup>
import PainMaleFigure from '@shared/components/PainMaleFigure.vue'
import PainFemaleFigure from '@shared/components/PainFemaleFigure.vue'
import { computed } from 'vue'
import useSelfTestStore from '@shared/modules/assessment/stores/useSelfTestStore.js'

defineProps({
  cssClasses: {
    type: Array,
    default: () => [],
  },
  bodyParts: {
    type: Array,
    default: () => [],
  },
})

const selfTestStore = useSelfTestStore()
const gender = computed(() => selfTestStore.gender)
</script>

<style lang="scss" scoped>
.pain_locations {
  height: 423px;
  width: 141px;
}
</style>
